import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Phoenix silhouette uses the ★1 tier art. The active rendering
// for Phoenix goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/phoenix_3tier.jpg.
export const Phoenix = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/phoenix-1.png" size={size} alt="phoenix" />
)
